import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 9F7385FB-733C-4C1F-AC88-684BE98F381B
 * name arrow-right-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowRightThickIcon = createSvgIcon(<><path d="M4,10V14H13L9.5,17.5L11.92,19.92L19.84,12L11.92,4.08L9.5,6.5L13,10H4Z" /></>, 'ArrowRightThickIcon');
export default ArrowRightThickIcon